import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, LogOut, Sparkles } from "lucide-react";
import { AiChatPanel } from "@/components/AiChatPanel";
import { tokenStorage } from "@/lib/api";

/**
 * Admin AI Helper — a full-height chat surface at /admin/ai-helper. Staff can
 * use it to draft partner replies, summarise leads, or ask for a quick
 * eligibility policy explainer. Model selectable from the top-right of the
 * chat header (GPT 5.6 Sol / Terra / Luna, or GPT 5.5).
 */
export default function AdminAiHelper() {
  const navigate = useNavigate();
  const logout = () => {
    tokenStorage.clear();
    navigate("/admin", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#0A1F44] text-white">
      <div className="border-b border-white/10 bg-black/30 sticky top-0 z-30 backdrop-blur-lg">
        <div className="max-w-[1200px] mx-auto flex items-center gap-3 px-6 py-3">
          <Link
            to="/admin"
            className="inline-flex items-center gap-1 text-xs text-white/60 hover:text-white/90"
          >
            <ArrowLeft size={13} /> Admin
          </Link>
          <div className="flex-1" />
          <button
            onClick={logout}
            className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full border border-rose-400/30 hover:border-rose-400/60 text-xs text-rose-200"
          >
            <LogOut size={12} /> Logout
          </button>
        </div>
      </div>

      <div className="max-w-[1000px] mx-auto px-6 py-6">
        <div className="mb-4">
          <div className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37] mb-1.5">
            Internal Copilot
          </div>
          <h1 className="font-display text-3xl text-white mb-1 flex items-center gap-2">
            <Sparkles className="text-[#F0D788]" size={26} />
            AI Helper
          </h1>
          <p className="text-sm text-white/60 max-w-2xl">
            Draft partner replies, summarise a lead file, ask eligibility questions.
            Powered by ChatGPT — replies are indicative and should not be treated as
            audit-authoritative.
          </p>
        </div>

        <div className="h-[calc(100vh-220px)] min-h-[500px]">
          <AiChatPanel variant="admin" />
        </div>
      </div>
    </div>
  );
}
